module.exports = __webpack_public_path__ + "static/media/youtube.1d34a7e1.svg";